import React from 'react'
import Typography from '@mui/material/Typography'
import { useSelector } from 'react-redux'
import colors from '../../../config/colors'

// Colors from the light theme that should become ultraSilver in dark/ultra mode
const LIGHT_MODE_COLORS = new Set([
  '#53575A', '#53575a', // colors.gray
  '#B1B1B1', '#b1b1b1', // colors.grayLight
  '#515558',            // colors.grayDark
  'black', '#000', '#000000',
])

const CustomLabel = ({ style, children }) => {
  const infoAfiliado = useSelector((state) => state.afiliado.infoAfiliado)
  const isDark = infoAfiliado.isUltra && infoAfiliado.ultraDarkMode

  const effectiveStyle =
    isDark && (!style?.color || LIGHT_MODE_COLORS.has(style?.color))
      ? { ...style, color: colors.ultraSilver }
      : style

  return (
    <Typography variant="h4" gutterBottom component="div" style={effectiveStyle}>
      {children}
    </Typography>
  )
}

export default CustomLabel